var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.validation,"name":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default",null,{"errors":!_vm._.isEmpty(errors)}),_c('p',{staticClass:"h-4 text-xs italic mb-2",class:_vm._.isEmpty(errors) || "text-error"},[_vm._v("\n    "+_vm._s(errors[0])+"\n  ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }